var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"processing-status"},[(_vm.saving && !_vm.saved)?_c('span',{staticClass:"text-muted"},[_vm._v(" Saving "),_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_vm._e(),(_vm.saved)?_c('span',{staticClass:"text-muted"},[_vm._v(" Saved! "),_c('i',{staticClass:"fas fa-check"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }